module.exports = __webpack_public_path__ + "static/media/pg12.ec192804.jpg";